import {dnsReg, ipReg} from "./utils";

const {weightedMean} = require("./math");
const {vsiGreen} = require("./themeStyles");
const dayjs = require("dayjs");
const negativeFieldRules = ['vm_build_capacity'];

export function randomNumBetween(num1, num2) {
    if (typeof num1 !== "number" || typeof num2 !== "number") return 0;
    return Math.floor(Math.random() * num2) + num1;
};

export function capitalizeWord(str) {
    if (!str) return str;
    if (str.split(" ")[1] || str.split("-")[1]) {
        let splitStr;
        if (str.split(" ")[1]) {
            splitStr = str.split(" ")
        } else if (str.split("-")[1]) {
            splitStr = str.split("-")
        }
        let newStr = splitStr.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
        })
        return newStr.join(" ");
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function capitalizeName(str) {
    if (!str) return str;
    if (str.split(" ")[1] || str.split("-")[1]) {
        let splitStr;
        let symbol;
        if (str.split(" ")[1]) {
            splitStr = str.split(" ")
            symbol = " "
        } else if (str.split("-")[1]) {
            splitStr = str.split("-")
            symbol = "-"
        }
        let newStr = splitStr.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
        })
        return newStr.join(symbol);
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function snakeToCamel(str) {
    return str.toLowerCase().replace(/([-_][a-z])/g, group =>
        group
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
    )
}

export function snakeCaseToTitleCase(str) {
    return str
        .replace(/_/g, " ")
        .toLowerCase()
        .split(" ")
        .map((x) => x.length > 2 ? x[0].toUpperCase() + x.slice(1) : x)
        .join(" ")
        .replace(/Percent/gi, "%")
        .replace(/Iops/gi, "IOPS");
}

export function kebabCaseToTitleCase(str) {
    return str
        .replace(/_/g, " ")
        .replace(/-/g, " ")
        .toLowerCase()
        .split(" ")
        .map((x) => x.length > 2 ? x[0].toUpperCase() + x.slice(1) : x)
        .join(" ")
        .replace(/Percent/gi, "%")
        .replace(/Iops/gi, "IOPS");
}

export function toSnakeCase(str) {
    return str && str.match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(s => s.toLowerCase())
        .join('_');
}

export function numberParser(params) {
    const parsed = parseFloat(params.newValue);
    return isNaN(parsed) ? null : parsed;
};

export function determineSideNavColor(active, theme) {
    if (active && theme.type === "light") return "lightgray";
    return theme.sideColor;
}

export const constructQsp = (qsp, name, value) => {
    if (!qsp && value) {
        return qsp + `?${name}=${encodeURIComponent(value)}`;
    } else if (qsp && value) {
        return qsp + `&${name}=${encodeURIComponent(value)}`;
    } else {
        return qsp;
    }
};

export function returnPathWithQuery(path, context, params) {

    let qsps = '';
    switch (context.toLowerCase()) {
        case "device":
            qsps = constructQsp(qsps, 'device_name', params.get('device_name'));
            qsps = constructQsp(qsps, 'wwn', params.get('wwn'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "host":
            qsps = constructQsp(qsps, 'device_name', params.get('device_name'));
            qsps = constructQsp(qsps, 'host_name', params.get('host_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "cluster":
            qsps = constructQsp(qsps, 'cluster_name', params.get('cluster_name'));
            qsps = constructQsp(qsps, 'vcenter_name', params.get('vcenter_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "vcenter":
            qsps = constructQsp(qsps, 'vcenter_name', params.get('vcenter_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "esx host":
            qsps = constructQsp(qsps, 'esx_host_name', params.get('esx_host_name'));
            qsps = constructQsp(qsps, 'cluster_name', params.get('cluster_name'));
            qsps = constructQsp(qsps, 'vcenter_name', params.get('vcenter_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "datastore":
            qsps = constructQsp(qsps, 'datastore_name', params.get('datastore_name'));
            qsps = constructQsp(qsps, 'cluster_name', params.get('cluster_name'));
            qsps = constructQsp(qsps, 'vcenter_name', params.get('vcenter_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "vm":
            qsps = constructQsp(qsps, 'cluster_name', params.get('cluster_name'));
            qsps = constructQsp(qsps, 'vcenter_name', params.get('vcenter_name'));
            qsps = constructQsp(qsps, 'vm_name', params.get('vm_name'));
            qsps = constructQsp(qsps, 'esx_host_name', params.get('esx_host_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        case "switch":
            qsps = constructQsp(qsps, 'switch_name', params.get('switch_name'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            qsps = constructQsp(qsps, 'device_type', params.get('device_type'));
            break;
        case "server":
            qsps = constructQsp(qsps, 'instance_name', params.get('instance_name'));
            qsps = constructQsp(qsps, 'device_type', params.get('device_type'));
            qsps = constructQsp(qsps, 'period_id', params.get('period_id'));
            break;
        default:
        // do nothing
    }

    return path + qsps;
}

export function returnTitleWithQuery(path, context, title, params) {
    let newTitle = title;
    switch (context.toLowerCase()) {
        case "device":
            newTitle += ` - ${params.get('device_name')}`;
            break;
        case "cluster":
            newTitle += ` - ${params.get('cluster_name')}`;
            break;
        case "esx host":
            newTitle += ` - ${params.get('esx_host_name')}`;
            break;
        case "datastore":
            newTitle += ` - ${params.get('datastore_name')}`;
            break;
        case "vm":
            newTitle += ` - ${params.get('vm_name')}`;
            break;
        default:
        // do nothing
    }

    return newTitle;
}

export const returnRootContextWithContext = context => {
    switch (context.toLowerCase()) {
        case "device":
        case "storage":
            return "Storage";
        case "cluster":
        case "esx host":
        case "datastore":
        case "vcenter":
        case "vm":
        case "virtual":
            return "Virtual";
        case "host":
        case "hosts":
            return "Hosts";
        case "switch":
        case "san switch":
        case "san-switch":
            return "SAN-Switch";
        case "server":
        case "database":
            return "Databases";
        case "cloud":
            return "Cloud";
        case "kubernetes":
            return "Kubernetes";
        case "security":
            return "Security";
        case "business unit":
            return "Business Unit";
        case "finops":
            return "FinOps";
        default:
            return snakeCaseToTitleCase(context);
    }
}

export function returnDriveColor(drive, theme) {

    if (drive?.is_failed) {
        return "red";
    }

    if (drive?.is_hot_spare) {
        return "darkorange";
    }
    switch (drive?.drive_type?.toLowerCase?.()) {
        case "fibre":
            return vsiGreen;
        case "sata":
            return "gold";
        case "sas":
            return "#007FFF";
        case "ssd":
            return theme.type === "dark" ? "#B39CD0" : '#8B00FF';
        case "unknown":
            return theme?.textColor || "black";
        case "empty":
            return "gray";
        case "hot spare":
            return "darkorange";
        case "failed":
            return "red";
        default:
            return vsiGreen;

    }
}

export function formatPhysicalDiagramEnclosures(diagrams) {
    const allLoops = {};
    const enclosureFields = [
        'enclosure_name',
        'enclosure_uid',
        'enclosure_serial_number',
        'enclosure_slots',
        'enclosure_speed',
        'enclosure_type',
        'enclosure_model',
        'enclosure_max_speed',
        'enclosure_firmware',
        "failed_drive_count",
        "hot_spare_count"
    ];
    const slotFields = [
        "device_physical_diagram_id",
        "wwn",
        "slot",
        "disk_group",
        "speed",
        "size",
        "is_hot_spare",
        "is_failed",
        "drive_type",
        "revision",
        "shelf_number",
        "drive_serial_number",
    ];

    diagrams.forEach(gram => {
        if (!allLoops[gram.loop]) {
            allLoops[gram.loop] = {
                loop_name: gram.loop,
                enclosures: {},
            }
        }

        const enclosureIdentifier = `${gram.enclosure_name}-${gram.enclosure_uid}`;

        if (!allLoops[gram.loop].enclosures[enclosureIdentifier]) {
            allLoops[gram.loop].enclosures[enclosureIdentifier] = {};
            enclosureFields.forEach(field => {
                allLoops[gram.loop].enclosures[enclosureIdentifier][field] = gram[field]
            });
            allLoops[gram.loop].enclosures[enclosureIdentifier].slots = {};
            if (typeof allLoops[gram.loop].enclosures[enclosureIdentifier].failed_drive_count === "undefined") {
                allLoops[gram.loop].enclosures[enclosureIdentifier].failed_drive_count = 0;
            }
            if (typeof allLoops[gram.loop].enclosures[enclosureIdentifier].hot_spare_count === "undefined") {
                allLoops[gram.loop].enclosures[enclosureIdentifier].hot_spare_count = 0;
            }
        }

        if (gram.is_failed) {
            allLoops[gram.loop].enclosures[enclosureIdentifier].failed_drive_count = allLoops[gram.loop].enclosures[enclosureIdentifier].failed_drive_count + 1;
        }
        if (gram.is_hot_spare) {
            allLoops[gram.loop].enclosures[enclosureIdentifier].hot_spare_count = allLoops[gram.loop].enclosures[enclosureIdentifier].hot_spare_count + 1;
        }

        if (!allLoops[gram.loop].enclosures[enclosureIdentifier].slots.hasOwnProperty(gram.slot)) {
            allLoops[gram.loop].enclosures[enclosureIdentifier].slots[gram.slot] = {};
            slotFields.forEach(field => {
                allLoops[gram.loop].enclosures[enclosureIdentifier].slots[gram.slot][field] = gram[field]
            });
        }

    });

    const diagramToReturn = [];
    for (const loopKey in allLoops) {
        const gram = {};
        gram.loop_name = loopKey;
        gram.enclosures = [];
        for (const encKey in allLoops[loopKey].enclosures) {
            const enclosure = {};
            enclosureFields.forEach(field => enclosure[field] = allLoops[loopKey].enclosures[encKey][field]);
            enclosure.slots = [];

            for (const slotKey in allLoops[loopKey].enclosures[encKey].slots) {
                const slot = {};
                slotFields.forEach(field => slot[field] = allLoops[loopKey].enclosures[encKey].slots[slotKey][field]);
                enclosure.slots.push(slot);
            }
            gram.enclosures.push(enclosure);
        }
        diagramToReturn.push(gram);
    }
    return diagramToReturn;
}

export function formatStockChartConfig(data, names, filter) {
    const labels = {};
    const categories = [];
    const newData = new Array(names.length);

    names.forEach((name, ni) => {
        labels[name.name] = [];
        newData[ni] = [];
    });

    data
        // .sort((a, b) => Date.parse(a.collection_date?.split?.('T')?.[0]) - Date.parse(b.collection_date?.split?.('T')?.[0]))
        .forEach((datum, index) => {
            const date = datum.collection_date?.includes?.('T') ? Date.parse(datum.collection_date?.split?.('T')?.[0]) : datum.collection_date;
            names.forEach((name, ni) => {
                if ((filter && datum[filter] === name.name) || !filter) {
                    const point = parseFloat(parseFloat(datum[name.field]).toFixed(2).toLocaleString());

                    labels[name.name].push(point);

                    const dataPoint = {
                        x: date,
                        y: point,
                    }

                    if (name.colorFilter) {
                        switch (name.colorFilter.name.toLowerCase()) {
                            case "forecast":
                                if (0 > dayjs().diff(dayjs(date))) {
                                    dataPoint.color = "white"
                                    dataPoint.marker = {
                                        enabled: false,
                                    }
                                }

                                break;
                            default:
                            // do nothing
                        }
                    }

                    newData[ni].push(dataPoint);
                    // newData[ni].push([date, point]);
                    if (!categories.includes(date)) {
                        categories.push(date);
                    }
                }
            });
        });

    return {
        categories,
        formattedChartData: names.map(name => ({name: name.name, data: labels[name.name], yAxis: name.yAxis})),
        data: newData,
        series: names.map((name, index) => ({
            name: name.name,
            type: name.type || null,
            yAxis: name.yAxis,
            data: newData[index],
            dataLabels: name.dataLabels || '{point.y}',
            dashStyle: name.dashStyle || 'solid',
            tooltip: name.tooltip || {
                valueDecimals: 2
            },
            marker: {
                enabled: !name.disableMarker,
            },
            zoneAxis: name.zoneAxis || null,
            zones: name.zones || null,
            zIndex: name.zIndex || 1
        }))
    }
}

export function formatDualAxisStockChartConfig(data, names, xAxisField) {
    const labels = {};

    const categories = [];
    const newData = new Array(names.length);
    names.forEach((name, ni) => {
        labels[name.name] = [];
        newData[ni] = [];
    });

    data
        .sort((a, b) => Date.parse(a.collection_date) - Date.parse(b.collection_date))
        .forEach((datum, index) => {
            let xAxisVal = xAxisField ? datum?.[xAxisField] : Date.parse(datum.collection_date);

            names.forEach((name, ni) => {
                const point = parseFloat(parseFloat(datum[name.field]).toFixed(2).toLocaleString());
                labels[name.name].push(point);
                newData[ni].push([xAxisVal, point]);
            });
            if (!categories.includes(xAxisVal)) {
                categories.push(xAxisVal);
            }
        });

    return {
        categories,
        formattedChartData: names.map(name => ({name: name.name, data: labels[name.name]})),
        data: newData,
        series: names.map((name, index) => ({
            name: name.name,
            type: name.type || null,
            data: newData[index],
            dataLabels: name.dataLabels || '{point.y}',
            dashStyle: name.dashStyle || 'Solid',
            yAxis: name.yAxis || 0,
            tooltip: name.tooltip || {
                valueDecimals: 2
            },
            marker: {
                enabled: !name.disableMarker,
            },
            zoneAxis: name.zoneAxis || null,
            zones: name.zones || null,
        }))
    }
}

export function dateFromPeriod(periodId) {
    // Reverse of periodFromDate
    let iniPeriod = 1827; // period id for 01/01/2020
    let iniDate = new Date('01/01/2020');

    let differenceInDays = periodId - iniPeriod;
    let differenceInTime = differenceInDays * (1000 * 3600 * 24);
    let ourDate = Math.round(differenceInTime + iniDate.getTime());
    ourDate = new Date(ourDate).toISOString()

    let splits = ourDate.split("-");
    let splitDay = splits[2].split("T");
    let day = splitDay[0];
    return `${splits[1]}/${day}/${splits[0]}`
}

export function periodFromDate(date) {
    // def get_period_id(self):
    //  ini_period = 1827  # period_id for 01/01/2020
    //  ini_date = datetime.date(2020, 1, 1)
    //  return ini_period + (datetime.datetime.strptime(self.collection_date, "%m/%d/%y").date()
    //                      - ini_date).days

    // Expect format mm/dd/yyyy
    let iniPeriod = 1827; // period id for 01/01/2020
    let iniDate = new Date('01/01/2020');
    let ourDate = new Date(date);

    let differenceInTime = ourDate.getTime() - iniDate.getTime();

    // To calculate the no. of days between two dates
    var differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));

    let total = (iniPeriod + differenceInDays);

    return total
}

export function uomValToLabel(uom) {
    switch (uom) {
        case "GB":
            return {value: "GB", label: "Gigabyte (GB)"};
        case "TB":
            return {value: "TB", label: "Terabyte (TB)"};
        case "PB":
            return {value: "PB", label: "Petabyte (PB)"};
        default:
            return;
    }
}

export function determineContext(context) {
    // switch (context) {
    //   case 'business-units':
    //     return 'business-units';
    //   case 'virtual':
    //     return 'virtual';
    //   case 'hosts':
    //     return 'hosts';
    //   case 'file-analysis':
    //   case 'backup':
    //   case 'switches':
    //   default:
    //     return 'DEVICE';
    // }
    return context;
}

export function forecastWithRateV2(data, fields, datesOut = 7, growthRate, forecastType) {
    let forecastedData = []
    if (data?.length > 1) {
        const lastDate = dayjs(data?.[data.length - 1]?.collection_date.replace('T', '').replace('Z', ''));
        let fields_growth = {}
        const mostRecent = data?.[data.length - 1];
        fields.forEach(field => {
            fields_growth[field] = {}
            fields_growth[field].origValue = data?.[data?.length - 1]?.[field];
            let idx = 1;
            let growths = []
            // Calculating Growths
            while (idx < 6 && data?.[data.length - (idx + 1)]) {
                growths.push(data[data.length - idx][field] - data[data.length - (idx + 1)][field]);
                idx++;
            }
            // Weighting Growths
            let weighted_growths = growths.map((g, i) => {
                if (i <= 2) return g * ((growths.length < 3 ? 1 : growths.length < 5 ? .8 : .7));
                else if (i <= 4) return g * .2
                else return g * .1
            });
            const div = growths.length === 1 ? 1 : growths.length in [2, 4] ? 2 : growths.length === 3 ? 1.8 : 2.1;

            // Calculating Growth
            const growth = weighted_growths.reduce((partialSum, a) => partialSum + a, 0) / div
            fields_growth[field].growth = field.includes('capacity') && growthRate !== null ? growthRate : growth;
        });
        for (let i = 1; i <= datesOut; i++) {
            const point_date = lastDate.add(i, (forecastType === 'Years' ? 'year' : 'month')).format('YYYY-MM-DDTHH:mm:ss.s[Z]');
            const newPoint = {
                ...mostRecent,
                isForecasted: true,
            };
            newPoint.collection_date = point_date;
            fields.forEach(field => {
                newPoint[field] = fields_growth[field].origValue + (fields_growth[field].growth * (i * (forecastType === 'Years' ? 12 : 1)));
            });
            forecastedData.push(newPoint);
        }
    }
    return forecastedData;
}

export const calculateWeightedGrowthRateDaily = (data, fields, numberOfWeeks = 6) => {


    // Check if there is enough data to calculate growth rate
    if (data.length < 2) {
        // returning an object with all growth rate fields at 0
        return 0.00;
    }
    if (data.length < (numberOfWeeks + 1)) {
        numberOfWeeks = data.length - 1;
    }
    // Calculate weighted growth rate
    const weights = [1, 0.5, 0.25, 0.125, 0.0625, 0.03125].slice(0, numberOfWeeks);
    const denominator = weights.reduce((total, value) => total + value, 0);
    const lastNData = data.slice(-(numberOfWeeks + 1)).sort((a, b) => dayjs(b.collection_date) - dayjs(a.collection_date));
    let result = {}
    fields.forEach(field => {
        let total = 0
        for (let i = 0; i < numberOfWeeks; i++) {
            total += (lastNData[i][field] - lastNData[i + 1][field]) * weights[i];
        }
        result[field] = {};
        result[field].growth = total / denominator / 7;
    });
    return result;
}

export function forecastWithRateV3(data, fields, datesOut, growthRates, forecastType) {
    //Forecast Type can now be Days, Weeks, Months, Years
    let forecastedData = []
    if (data?.length > 1) {
        const lastDate = dayjs(data?.[data.length - 1]?.collection_date.replace('T', '').replace('Z', ''));
        let fields_growth = {}
        const mostRecent = data?.[data.length - 1];
        fields.forEach(field => {
            fields_growth[field] = {}
            fields_growth[field].origValue = data?.[data?.length - 1]?.[field];
            for (let i = 1; i <= datesOut; i++) {
                const point_date = lastDate.add(i, (forecastType === 'Years' ? 'year' : forecastType === 'Months' ? 'month'
                    : forecastType === 'Weeks' ? 'week' : 'day')).format('YYYY-MM-DDTHH:mm:ss.s[Z]');
                const newPoint = {
                    ...mostRecent,
                    isForecasted: true
                };
                newPoint.collection_date = point_date;
                newPoint.growth = growthRates[field].growth
                newPoint[field] = mostRecent[field] + (i * growthRates[field].growth * (forecastType === 'Years' ? 365 : forecastType === 'Months' ? 30
                    : forecastType === 'Weeks' ? 7 : 1));
                forecastedData.push(newPoint);

            }
        });
    }
    return forecastedData;
}

export function forecastWithRate(data, fields, datesOut = 7, growthRate, forecastType) {
    const runningTotals = {};
    for (let i = 0; i < fields.length; i++) {
        if (!runningTotals[fields[i]]) {
            runningTotals[fields[i]] = {
                sum: 0,
                rate: 0,
                running: 0,
            };
        }
        runningTotals[fields[i]].weights = [];
        runningTotals[fields[i]].weightedData = [];
    }

    const splitTime = Math.floor(data.length / 3);

    data.forEach((datum) => {
        const pointDay = dayjs(datum.collection_date.replace('T', '').replace('Z', ''));
        const today = dayjs(data[data.length - 1].collection_date);
        const diff = forecastType === 'Years' ? today.diff(pointDay, 'year') : today.diff(pointDay, 'month');
        const weight = diff <= splitTime ? .7 : diff >= (splitTime * 2) ? .1 : .2;
        for (let j = 0; j < fields.length; j++) {
            runningTotals[fields[j]].weightedData.push(datum[fields[j]]);
            runningTotals[fields[j]].weights.push(weight);
        }
    });

    for (let i = 0; i < fields.length; i++) {
        const thisTotal = runningTotals[fields[i]];
        const sum = weightedMean(thisTotal.weightedData, thisTotal.weights);
        runningTotals[fields[i]].sum = sum;
        runningTotals[fields[i]].rate = (sum / (data?.[data.length - 1]?.[fields[i]] || 0));
    }

    const lastDate = dayjs(data?.[data.length - 1]?.collection_date.replace('T', '').replace('Z', ''));

    const forecastedData = [];
    // 6 months future
    for (let i = 1; i < datesOut; i++) {
        const mostRecent = data?.[data.length - 1];
        const newPoint = {
            ...mostRecent,
        };
        const newDate = forecastType === 'Years' ? lastDate.add(i, 'year') : lastDate.add(i, 'month');
        newPoint.collection_date = newDate.format('YYYY-MM-DDTHH:mm:ss.s[Z]');
        let monthsOut = forecastType === 'Years' ? i * 12 : i;
        for (let j = 0; j < fields.length; j++) {
            let fieldValInRange = mostRecent?.[fields[j]] * monthsOut;
            let rate = runningTotals?.[fields[j]]?.rate;
            let adjsRate = (1 - rate);
            let addedVal = fieldValInRange + ((fieldValInRange * ((growthRate || growthRate === 0) ? growthRate : adjsRate)) * monthsOut);
            const point = parseFloat((addedVal / monthsOut).toFixed(2)) || 0;

            newPoint[fields[j]] = (point && point > 0) ? point : 0;
        }
        forecastedData.push(newPoint);
    }
    return [...data, ...forecastedData];

}

export const lightOrDark = (color) => {
    if (!color) return null;
    // Variables for red, green, blue values
    let r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        // Check if the color is yellow
        if (color === 'yellow') return 'light';
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        // eslint-disable-next-line no-mixed-operators
        g = color >> 8 & 255;
        b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {

        return 'light';
    } else {

        return 'dark';
    }
};

export const findEarliestDate = (dateList, startDay, endDate) => {
    for (let i = dateList.length - 1; i >= 0; i--) {
        if (new Date(dateList[i]).getTime() >= new Date(startDay).getTime() && new Date(dateList[i]).getTime() !== new Date(endDate).getTime()) {
            return dateList[i];
        }
    }
};

export const forecastWithGrowthFunc = (recentData, changedVal, growth, months, forecastType) => {

    let forecastArr = [];

    // loop to create forecast for x months
    for (let i = 1; i <= months; i++) {
        let dateArr = recentData?.collection_date?.split('-');
        let month = parseInt(dateArr?.[1]) + i;
        let year = parseInt(dateArr?.[0]);
        if (month > 12) {
            month = month - 12;
            year++;
        }
        ;
        let newDate = month + '/' + year;
        let monthsOut = forecastType === 'Years' ? i * 12 : i;
        let forecastAmt = recentData?.[changedVal] + ((growth / 100) * recentData?.[changedVal] * monthsOut);
        if (forecastAmt < 0) {
            forecastAmt = 0;
        }
        ;

        if (forecastType === 'Years') {
            var forecastDate = new Date(recentData?.collection_date).setFullYear(new Date(recentData?.collection_date).getFullYear() + i);
        } else {
            forecastDate = new Date(recentData?.collection_date).setMonth(new Date(recentData?.collection_date).getMonth() + i);
        }
        ;

        forecastArr.push({
            ...recentData,
            formatted_date: newDate,
            collection_date: forecastDate ? new Date(forecastDate).toISOString() : null,
            [changedVal]: forecastAmt
        });
    }

    return forecastArr;
};

export const forecastFunc = (data, fields, datesOut = 7, growthRate, drRatio, forecastType) => {
    if (!data || data.length === 0) return [];

    const runningTotals = {};

    for (let i = 0; i < fields.length; i++) {
        if (!runningTotals[fields[i]]) {
            runningTotals[fields[i]] = {
                sum: 0,
                rate: 0,
                running: 0,
            };
        }
        runningTotals[fields[i]].weights = [];
        runningTotals[fields[i]].weightedData = [];
    }

    const splitTime = Math.floor(data.length / 3);

    data.forEach((datum) => {
        const pointDay = dayjs(datum.collection_date.replace('T', '').replace('Z', ''));
        const today = dayjs(data[data.length - 1].collection_date);
        const diff = today.diff(pointDay, 'month');
        const weight = diff <= splitTime ? .95 : diff >= (splitTime * 2) ? .01 : .04;
        for (let j = 0; j < fields.length; j++) {
            runningTotals[fields[j]].weightedData.push(datum[fields[j]]);
            runningTotals[fields[j]].weights.push(weight);
        }
    });

    for (let i = 0; i < fields.length; i++) {
        const thisTotal = runningTotals[fields[i]];
        const sum = weightedMean(thisTotal.weightedData, thisTotal.weights);
        runningTotals[fields[i]].sum = sum;
        runningTotals[fields[i]].rate = (sum / (data?.[data.length - 1]?.[fields[i]] || 0));
    }

    const lastDate = dayjs(data?.[data.length - 1]?.collection_date.replace('T', '').replace('Z', ''));

    const forecastedData = [];
    // 6 months future
    for (let i = 1; i <= datesOut; i++) {
        const mostRecent = data?.[data.length - 1];
        const newPoint = {
            ...mostRecent,
        };
        if (forecastType === 'Years') {
            var newDate = lastDate.add(i, 'year');
        } else {
            newDate = lastDate.add(i, 'month');
        }
        ;

        newPoint.collection_date = newDate.format('YYYY-MM-DDTHH:mm:ss.s[Z]');
        for (let j = 0; j < fields.length; j++) {
            if (forecastType === 'Years') {
                var iteration = i * 12;
            } else {
                iteration = i;
            }
            let fieldValInRange = mostRecent?.[fields[j]] * (iteration);
            let rate = runningTotals?.[fields[j]]?.rate;
            let adjsRate = 1 - rate;
            if (drRatio && (fields[j] === 'capacity_gb' || fields[j] === 'capacity')) {
                var addedVal = fieldValInRange + ((fieldValInRange * ((drRatio / 100))) * (iteration));
            } else {
                let growth = ((growthRate === null) || (!growthRate && growthRate !== 0)) ? adjsRate : ((growthRate / 100) || 0);
                addedVal = fieldValInRange + ((fieldValInRange * (growth)) * (iteration));
            }
            ;
            const point = parseFloat((addedVal / (iteration)).toFixed(2)) || 0;

            newPoint[fields[j]] = (point && point > 0) ? point : 0;
        }
        ;
        forecastedData.push(newPoint);
    }
    ;

    return forecastedData;
};

export const addCapAndWorkload = (forecastArr, capAmt, workloadAmt) => {
    if (capAmt) {
        capAmt = parseInt(capAmt);
        forecastArr = forecastArr.map(forecast => {
            return {
                ...forecast,
                capacity_gb: forecast.capacity_gb + capAmt,
                subscription_capacity_gb: forecast.subscription_capacity_gb + capAmt,
                order_capacity_gb: forecast.order_capacity_gb + capAmt,
                physical_capacity_gb: forecast.physical_capacity_gb + capAmt,
                physical_subscription_capacity_gb: forecast.physical_subscription_capacity_gb + capAmt,
                physical_order_capacity_gb: forecast.physical_order_capacity_gb + capAmt
            };
        });
    }
    ;

    if (workloadAmt) {
        workloadAmt = parseInt(workloadAmt);
        forecastArr = forecastArr.map(forecast => {
            return {
                ...forecast,
                used_gb: forecast.used_gb + workloadAmt,
                physical_used: forecast.physical_used + workloadAmt
            };
        });
    }
    ;

    return forecastArr;
};

export const addEntCapAndWorkload = (forecastArr, capAmt, workloadAmt) => {
    if (capAmt) {
        capAmt = parseInt(capAmt);
        forecastArr = forecastArr.map(forecast => {
            return {
                ...forecast,
                effective_capacity: forecast.effective_capacity + capAmt,
                subscription_capacity: forecast.subscription_capacity + capAmt,
                order_capacity: forecast.order_capacity + capAmt,
                physical_effective_capacity: forecast.physical_effective_capacity + capAmt,
                physical_subscription_capacity: forecast.physical_subscription_capacity + capAmt,
                physical_order_capacity: forecast.physical_order_capacity + capAmt
            };
        });
    }
    if (workloadAmt) {
        workloadAmt = parseInt(workloadAmt);
        forecastArr = forecastArr.map(forecast => {
            return {
                ...forecast,
                used: forecast.used + workloadAmt,
                physical_used: forecast.physical_used + workloadAmt
            };
        });
    }
    return forecastArr;
};

export const formatGroupedDataForTrend = (data = [], fieldValue = '', fieldToCheck = '', fields = []) => {
    const dates = {};
    const dataToReturn = [];
    data.forEach(datum => {
        if (!dates.hasOwnProperty(datum.collection_date)) {
            dates[datum.collection_date] = {};
        }

        const isContained = fields.some(el => {
            return el?.toLowerCase?.() === datum[fieldToCheck]?.toLowerCase?.();
        })

        if (isContained) {
            dates[datum.collection_date] = {
                ...datum,
                [snakeCaseToTitleCase(datum[fieldToCheck])]: datum[fieldValue],
            };
        }
    });

    for (let key in dates) {
        dataToReturn.push({
            ...dates[key]
        });
    }
    return dataToReturn.sort((a, b) => new Date(a) - new Date(b));
}

export const getContextForReportName = context => {
    switch (context?.toLowerCase() || '') {
        case 'host':
        case 'hosts':
            return 'host';
        default:
            return context;
    }
}

export const calculateWeightedGrowthRate = (data, fields, numberOfMonths = 6) => {
    // Check if fields array is provided
    if (!Array.isArray(fields) || fields.length === 0) {
        return {};
    }

    // Check if there is enough data to calculate growth rate
    if (data.length < 2) {
        // returning an object with all growth rate fields at 0
        return fields.reduce((obj, nextVal) => {
            obj[nextVal] = 0;
            return obj;
        }, {});
    }

    // Calculate weighted growth rate
    const weights = [1, 0.5, 0.25, 0.125, 0.0625, 0.03125];
    const lastNData = data.slice(-numberOfMonths);

    const growthRate = fields.reduce((result, field) => {
        const availableData = lastNData.slice(0, data.length);
        const weightedSum = availableData.reduce((sum, obj, index) => {
            return sum + obj[field] * weights[index];
        }, 0);

        const denominator = weights.slice(0, availableData.length).reduce((sum, weight) => sum + weight, 0);
        const average = weightedSum / denominator;

        const rate = 1 - (lastNData[lastNData.length - 1][field] / average) || 0;
        result[field] = rate ? -(rate * 100).toFixed(4) : 0;
        return result;
    }, {});

    return growthRate;
}

function convertGrowthRates(weeklyRate) {
    // Convert percentage to a decimal for calculation

    // Number of weeks in a month and a year
    const weeksInMonth = 4.345238;
    const weeksInYear = 52.14286;

    // Calculate monthly growth rate
    let monthlyRate = weeklyRate * weeksInMonth / 100;

    // Calculate yearly growth rate
    let yearlyRate = weeklyRate * weeksInYear / 100;

    return {
        week: weeklyRate,
        month: monthlyRate,
        year: yearlyRate
    };
}

export const applyGrowthRateToNext = (data, fields, growthRate, numPredictions = 7, forecastType = "month") => {
    const predictions = new Array(numPredictions);
    // Check if fields array and growthRate object are provided
    if (!Array.isArray(fields) || fields.length === 0 || typeof growthRate !== 'object' || Object.keys(growthRate).length === 0) {
        return [];
    }

    // Check if numPredictions is a positive integer
    if (!Number.isInteger(numPredictions) || numPredictions <= 0) {
        return [];
    }

    // must have at least one data point to create prediction
    if (data.length < 1) {
        return [];
    }

    // Create a new array for predictions
    const currData = data[data.length - 1];
    const currDate = dayjs(currData?.collection_date);
    const running = {};
    let itr = 0;

    const growthRateKeyed = Object.keys(growthRate);
    // if there is no growth rate supplied, or it is undefined, just create one using simple avg
    if (!growthRateKeyed.length || growthRateKeyed.every(key => growthRate[key] === undefined)) {
        return forecastWithRateV2(data, fields, numPredictions, null, forecastType);
    }

    for (let i = 0; i < numPredictions; i++) {
        itr += 1;
        const thisDate = currDate.add(itr, forecastType);
        const nextData = {
            collection_date: thisDate.format('YYYY-MM-DDTHH:mm:ss.s[Z]'),
            month: thisDate.format('MM/YYYY'),
            isForecasted: true,
        };

        fields.forEach((field) => {
            // Use the growth rate to predict the next value
            const rate = forecastType === "month" ? growthRate[field] : growthRate[field] * 12;
            if (!running[field]) {
                let val = currData[field];
                if (val < 0 && rate < 0) {
                    val = -val;
                }
                running[field] = (val * (rate || 0));
            }
            const nextValue = currData[field] + running[field] * (i + 1);
            const negativeRule = (!negativeFieldRules.includes(field) && nextValue < 0);
            nextData[field] = negativeRule ? 0 : nextValue;
        });

        predictions[i] = nextData;
    }

    return predictions;
}

export const returnDates = (date = null) => {
    const dates = [];
    for (let i = 1; i < 11; i++) {
        const thisDate = (date ? dayjs(date) : dayjs()).add(i, 'month');
        const monthYear = thisDate.format('MM/YYYY');
        dates.push({
            value: monthYear,
            label: monthYear,
            parsedDate: Date.parse(thisDate)
        });
    }
    return dates;
}

export const differenceInMonths = (earlierDate, laterDate) => {
    var months = (new Date(laterDate).getFullYear() - new Date(earlierDate).getFullYear()) * 12;
    months = months - new Date(earlierDate).getMonth() + new Date(laterDate).getMonth();

    return months <= 0 ? 0 : months;
};

export const differenceInYears = (earlierDate, laterDate) => {
    var years = (new Date(laterDate).getFullYear() - new Date(earlierDate).getFullYear());

    return years <= 0 ? 0 : years;
};

export const calculateSessionTimeRemaining = (user) => {
    let currentDay = dayjs(new Date(user.lastLogin));
    let futureDay = currentDay.add(user.uiTimeout, 'minute');

    if (user.lastLogin && user.uiTimeout) {
        let remainingMin = futureDay.diff(new Date(), 'minute').toLocaleString();
        let hours = parseInt((parseInt(remainingMin.replace(',', '')) / 60));
        let minutes = (parseInt(remainingMin.replace(',', ''))) - hours * 60;

        if (Math.sign(minutes) === -1) {
            minutes = 0;
        }
        ;

        return `${hours} hr ${minutes} min`;
    } else {
        return `0 min`;
    }
};

export const formatDataWithAcknowledgedAndSeverity = (alertData, type, option = 'all') => {
    if (type === 'acknowledged') {
        return alertData.filter(datum => {
            return datum.acknowledged && (option === 'all' ? true : datum.severity === option);
        });
    } else if (type === 'unacknowledged') {
        return alertData.filter(datum => {
            return !datum.acknowledged && (option === 'all' ? true : datum.severity === option);
        });
    }
    return alertData.filter(datum => {
        return option === 'all' ? true : datum.severity === option;
    });
}

export const validateIp = ipAddress => {
    if (ipAddress?.includes?.(",")) {
        return !ipAddress
            .split(",")
            .every((ip) => (Boolean(ipReg?.test(ip)) || Boolean(dnsReg?.test(ip))));
    }
    return (
        Boolean(ipAddress?.trim?.()) ||
        Boolean(ipReg?.test(ipAddress)) ||
        Boolean(dnsReg?.test(ipAddress))
    );
};

export const trueNumberValueFromString = value => parseFloat(
    value
        ?.toString?.()
        ?.replace?.(/[^\d.+-]/g, '')   // keep digits . + -
        ?.replace?.(/(?!^)[+-]/g, '')  // remove extra signs
        ?.replace?.(/^([+-]?\d*\.\d*)\./, '$1')) ?? 0;

export const handleAagTitle = (title, field) => {
    if (title) return title;
    return snakeCaseToTitleCase(field).replace("Vm", "VM").replace("vm", "VM").replace("Cpu", "CPU").replace("Ghz", "GHz");
};

export const formatAagValue = (value, field, dollarSign) => {
    if (["raw_disk", "total_usable", "total_used", "total_free", "effective_free_space", "total_snap", "dedupe"].includes(value)) {
        if (typeof value === 'number') {
            return value.toLocaleString("en-US", {minimumFractionDigits: 2});
        } else if (typeof value === "string" && value.trim() === "") {
            return "N/A";
        } else if (value === null || value === undefined) {
            return "N/A";
        }
    } else if (dollarSign) {
        if (typeof value === 'number') {
            return value.toLocaleString("en-US", {minimumFractionDigits: 2})
        } else {
            return "N/A"
        }
    } else {
        if (typeof value === 'number') {
            return value.toLocaleString();
        } else if (typeof value === "string" && value.trim() === "") {
            return "N/A";
        } else if (value === null || value === undefined) {
            return "N/A";
        }
        return value;
    }
}


export function getColor(value) {
    return (
        value < 16 ? 'blue' :
            value < 65 ? 'green' :
                value < 81 ? 'yellow' :
                    'red'
    );
}

export const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
        e.target.focus()
    }, 0)
}

export const simpleGrowthRate = (data, statisticField) => {
    /*
    Takes in all the data along with the name of the field that contains the capacity and the name
    that contains the utilization field.  An array of deltas is computed between each metric and
    the utilization number vs the one before it.  The simple average of the delta array is the growth rate.  The growth
    rate is applied in a linear fashion to show the forecasted data points.  This does not conform
    to the rules of storage forecasting, so don't try to apply the same rules and logic from other
    growth rate calculations.
     */
    let statisticValues = data.map(datum => datum[statisticField]);
    let deltaArray = statisticValues.slice(1).map((currentVal, i) => currentVal - statisticValues[i]);
    return (deltaArray.reduce((a, b) => a + b, 0)) / deltaArray.length;
};

export const simpleForecast = (data, fields, growth, numPredictions) => {
    // Create a new array for predictions
    // Check if fields array and growthRate object are provided
    if (!Array.isArray(fields) || fields.length === 0 || typeof growth !== 'object' || Object.keys(growth).length === 0) {
        return [];
    }

    // Check if numPredictions is a positive integer
    if (!Number.isInteger(numPredictions) || numPredictions <= 0) {
        return [];
    }

    // must have at least one data point to create prediction
    if (data.length < 1) {
        return [];
    }


    const predictions = new Array(numPredictions);
    const currData = data[data.length - 1];
    const currDate = dayjs(currData?.collection_date);
    const running = {};
    let itr = 0;
    for (let i = 0; i < numPredictions; i++) {
        itr += 1;
        const thisDate = currDate.add(itr, 'week');
        const nextData = {
            collection_date: thisDate.format('YYYY-MM-DDTHH:mm:ss.s[Z]'),
            month: thisDate.format('MM/YYYY'),
            isForecasted: true,
        };

        fields.forEach((field) => {
            const nextValue = currData[field] + growth[field] * (i + 1);
            // const negativeRule = (!negativeFieldRules.includes(field) && nextValue < 0);
            // nextData[field] = negativeRule ? 0 : nextValue;
            nextData[field] = nextValue;
        });
        predictions[i] = nextData;
    }
    return predictions;
}

export const isValidJWT = token => {
    // Split the token into its parts (header, payload, signature)
    const parts = token.split('.');

    // JWT must consist of 3 parts
    if (parts.length !== 3) {
        return false;
    }

    // Base64URL validation (for header and payload)
    const base64UrlPattern = /^[A-Za-z0-9-_]+$/;

    // Validate that both the header and payload are valid Base64URL strings
    const isBase64UrlValid = parts.every(part => base64UrlPattern.test(part));

    return isBase64UrlValid;
}
